/* eslint-disable max-len */
import React, { Component } from 'react';
import { withLocalize } from 'react-localize-redux';

import { Header, Label, Icon, Button } from 'semantic-ui-react';
import { NavLink } from 'react-router-dom';

import styled from 'styled-components';
import { Field } from 'formik';
import { Project } from '../common/constant';
// import { IMAGE_RESIZE } from '../network/api';
import { formatDate, formatDateTime } from '../common/datetime';
import BingMaps from '../common/bingMaps';
import { HHContentEditor } from './fields';

class EventFormDetailPreview extends Component {
  resizeIframe = () => {
    this.iframeObj.setAttribute(
      'style',
      `height: ${this.iframeObj.contentWindow.document.body.scrollHeight}px`
    );
  };

  render() {
    const { values, translate, activeLanguage } = this.props;

    const eventStatus = (
      <span className='eventDetail_coverImage_info_status event-status joinNow'>
        {translate('Coming Soon')}
      </span>
    );

    // const bannerBg = values.bannerBg
    //   ? IMAGE_RESIZE('w1000', values.bannerBg)
    //   : Project.defaultCoverImage;

    const bannerBg = values.bannerBgTempUrl
      ? values.bannerBgTempUrl
      : Project.defaultCoverImage;

    // &quot;https://hhfs-dev.hackhub.com/transform?size=w1000&amp;file=https://hhe-temporary-dev.s3.us-west-2.amazonaws.com/Yumi81/pYJkwbKkplTZb..jpeg?AWSAccessKeyId=AKIAJGZIGOODRNBEN2TQ&amp;Expires=1660760103&amp;Signature=FU21nmTeUTXQ3JcKbhravtKkllU%3D&quot;);

    const btnLabel = (values.isScreening === true) ? translate('Apply To Join') : translate('Join Now');

    const eventWithComputedData = {
      ...values,
      formattedStartDate: formatDate(
        values.start,
        activeLanguage,
        values.timezone
      ),
      formattedEndDate: formatDate(values.end, activeLanguage, values.timezone),
      formattedSubDeadline: formatDate(
        values.subDeadline,
        activeLanguage,
        values.timezone
      ),
      formattedStartDateTime: formatDateTime(
        values.start,
        activeLanguage,
        values.timezone
      ),
      formattedEndDateTime: formatDateTime(
        values.end,
        activeLanguage,
        values.timezone
      ),
      formattedSubDeadlineTime: formatDateTime(
        values.subDeadline,
        activeLanguage,
        values.timezone
      )
    };

    return (
      <div className='preview-detail'>
        <div className='cms-main eventDetail'>
          <div
            className='eventDetail_coverImage'
            style={{
            maxWidth: '100%',
            backgroundPosition: 'center',
            backgroundImage: `url(${bannerBg})`
            // backgroundImage: `${bannerBg})`
          }}
          >
            <div className='eventDetail_coverImage_info'>
              {eventStatus}
              <span className='eventDetail_coverImage_info_date'>
                <Icon name='calendar outline' />
                {eventWithComputedData.formattedStartDate} -
                {eventWithComputedData.formattedEndDate}
              </span>
              <span className='eventDetail_coverImage_info_deadline'>
                <Icon name='time' />
                {eventWithComputedData.formattedSubDeadlineTime}
              </span>
            </div>
          </div>
          <div className='eventDetail_header'>
            <h1 className='eventDetail_header_heading'>{values.name}</h1>

            <div className='eventDetail_header_nav'>
              <ul className='eventDetail_header_nav_list'>
                <li className='eventDetail_header_nav_list_item-details'>
                  <span className='active'>{translate('details')}</span>
                </li>

                <li className='eventDetail_header_nav_list_item-details'>
                  <StyledNavLink exact to='#' activeClassName='active'>
                    <i className='fal fa-user-alt' />
                    {translate('All Teams')}
                    <Label
                      circular floating className='margin-l-1'
                      color='teal'
                    >
                      0
                    </Label>
                  </StyledNavLink>
                </li>

                <li className='eventDetail_header_nav_list_item-details'>
                  <StyledNavLink exact to='#' activeClassName='active'>
                    <i className='fal fa-fw fa-star' />
                    {translate('submissions')}
                    <Label
                      circular floating className='margin-l-1'
                      color='teal'
                    >
                      0
                    </Label>
                  </StyledNavLink>
                </li>

                <li className='eventDetail_header_nav_list_item-details'>
                  <StyledNavLink to='#' exact activeClassName='active'>
                    <i className='fal fa-fw fa-book' />
                    {translate('common.resources')}
                    <Label
                      circular floating className='margin-l-1'
                      color='teal'
                    >
                      0
                    </Label>
                  </StyledNavLink>
                </li>
              </ul>
            </div>
            <div className='eventDetail_header_action'>
              <Button className='g-btn-primary g-rounded g-gradient'>
                {btnLabel}
              </Button>

            </div>
          </div>

          <div className='eventDetail_main'>
            <div className='eventDetail_main_detail empty'>
              <section style={{ paddingTop: '16px' }}>
                <Field
                  name='contentJson'
                  isPreview
                  component={HHContentEditor}
                />
              </section>
            </div>

            <section className='eventDetail_main_infobar'>
              <div className='eventDetail_main_infobar_date'>
                <Header as='h2'>{translate('eventDate')}</Header>
                <ul className='eventDetail_main_infobar_date_list'>
                  <li className='eventDetail_main_infobar_date_list_startDate'>
                    <span className='caption'>{translate('eventStart')}</span>
                    <span className='span_preview'>
                      {formatDateTime(
                      values.start,
                      activeLanguage.code,
                      values.timezone
                    )}
                    </span>
                  </li>
                  <li className='eventDetail_main_infobar_date_list_endDate'>
                    <span className='caption'>{translate('eventEnd')}</span>
                    <span>
                      {formatDateTime(
                      values.end,
                      activeLanguage.code,
                      values.timezone
                    )}
                    </span>
                  </li>
                  <li className='eventDetail_main_infobar_date_list_deadline'>
                    <span className='caption'>
                      {translate('Submission Deadline')}
                    </span>
                    <span>
                      {formatDateTime(
                      values.subDeadline,
                      activeLanguage.code,
                      values.timezone
                    )}
                    </span>
                  </li>
                </ul>
              </div>

              <div className='eventDetail_main_infobar_location'>
                <Header as='h2'>{translate('location')}</Header>
                <BingMaps location={values.location} />
              </div>
            </section>
          </div>
        </div>
      </div>
    );
  }
}

const StyledNavLink = styled(NavLink)({
  position: 'relative'
});

export default withLocalize(EventFormDetailPreview);



// WEBPACK FOOTER //
// ./src/components/forms/eventFormDetailPreview.js